import InterfacePasien from "../apiInterface/InterfacePasien";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataPasien {
  async getDetailPemeriksaan(idReg) {
    let dt: any;
    await InterfacePasien.getDetailPemeriksaan(idReg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Detail Pasien");
        // console.log(e);
        // dt = {
        //   status: 0,
        //   err: e.response
        // }
        // if (dt['status'] == 422) {
        //   dt = { status: 0, err: "Gagal Ambil Data Detail Pasien ERROR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "Gagal Ambil Data Detail Pasien ERROR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async updateAlergiPasien(rm, alergi) {
    let dt: object = {};
    await InterfacePasien.updateAlergi(rm, alergi)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async getDetailKonsulan(id) {
    let dt: object = {};
    await InterfacePasien.getDetailKonsulan(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Detail Pasien Konsul");
      });
    return dt;
  }

  async getDataPasien(rm) {
    // console.log(rm)
    let dt: any;
    await InterfacePasien.getPasien(rm)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Identitas Pasien");
      });
    return dt;
  }

  async getDataPasienLastReg(rm) {
    // console.log(rm)
    let dt: any;
    await InterfacePasien.getPasienLastReg(rm)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Identitas Pasien Dengan Register Terakhir");
      });
    return dt;
  }

  async getDataPasienByParam(term) {
    // console.log(rm)
    let dt: any;
    await InterfacePasien.getPasienByParam(term)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Data Pasien");
      });
    return dt;
  }

  // async getDataKunjunganPasien(rm) {
  //   // console.log(rm)
  //   let dt: any;
  //   await InterfacePasien.getKunjunganPasien(rm)
  //     .then(response => {
  //       dt = response.data;
  //       // console.log(dt)
  //     })
  //     .catch(e => {
  //       console.log(e);
  //       dt = e.response;
  //       ErrorAlert.showSnackAlert(e, "Identitas Pasien");
  //     });
  //   return dt;
  // }
}

export default new DataPasien();
